package com.milta.core.localization.translations.es

import com.milta.core.localization.AdminUsersStrings

internal val AdminUsers = AdminUsersStrings(
    loading = "Cargando…",
    errorNoConnection = "No se puede contactar con el servidor — comprueba tu conexión.",
    errorGeneric = "Se produjo un error. Inténtalo de nuevo más tarde.",
    readOnlyNotice = "🔒 Solo consulta — todavía no se puede crear, modificar ni suspender ninguna cuenta desde esta pantalla.",
    kpiAccountsLabel = "Cuentas",
    kpiAccountsSubtitle = "todos los roles combinados",
    kpiDriversLabel = "Conductores",
    kpiDriversSubtitle = "sin equipo propio",
    kpiPatronsLabel = "Propietarios",
    kpiPatronsOrgSingular = "organización",
    kpiPatronsOrgPlural = "organizaciones",
    kpiActiveSubsLabel = "Suscripciones activas",
    kpiActiveSubsSubtitle = "activa + período de gracia",
    kpiAtRiskLabel = "En riesgo",
    kpiAtRiskSubtitle = "prueba o expirada",
    searchPlaceholder = "Buscar por nombre, email, organización…",
    expandAllAction = "Expandir todo",
    collapseAllAction = "Contraer todo",
    columnAccount = "Cuenta",
    columnContact = "Contacto",
    columnType = "Tipo",
    columnAddedDate = "Añadido / creada el",
    columnSubscription = "Suscripción",
    columnSince = "Desde",
    columnRenewal = "Renov.",
    noOrganizationHeader = "Sin organización",
    emptySearchResult = "Ninguna cuenta coincide con esta búsqueda.",
    patronBadgePrefix = "Propietario",
    createdOnPrefix = "Creada el",
    emptyTeamMessage = "Todavía no hay conductores en este equipo.",
    driverBadge = "Conductor",
    addedOnPrefix = "Añadido el",
    viaOrganization = "Vía organización",
    accountCreatedOnUnknown = "Cuenta creada el —",
    renewalSingular = "renovación",
    renewalPlural = "renovaciones",
    subscriptionNone = "Ninguna",
    subscriptionActive = "Activa",
    subscriptionTrial = "Prueba",
    subscriptionGrace = "Gracia",
    subscriptionExpiredStatus = "Expirada",
    subscriptionCancelled = "Cancelada",
    planOrganization = "Organización",
    planDriver = "Conductor",
)
